// Itinerary ids are plain references (NX/NIX prefixed booking refs), so anything outside this
// shape did not come from us. The id lands inside a URL path, where a slash would inject a route
// segment and dots would allow traversal, so validate rather than trust the query param.
const ITINERARY_ID_PATTERN = /^[A-Za-z0-9_-]{1,64}$/

/**
 * Builds the itinerary info page path for an id received as a query param.
 * Returns null for a missing or malformed id so callers can fall back.
 */
export const getItineraryInfoPath = (itineraryId: string | null | undefined, locale: string): string | null => {
    if (!itineraryId || !ITINERARY_ID_PATTERN.test(itineraryId)) return null

    return `/${locale}/flights/itinerary/${itineraryId}/info`
}
